export default from './MobileNavTabs';



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/MobileNavTabs/index.js